/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
`

export default class FavoriteIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" css={Color} className="favorite-svg">
        <g id="그룹_19033" data-name="그룹 19033" transform="translate(-307 -517)">
          <rect id="사각형_6435" data-name="사각형 6435" width="30" height="30" transform="translate(307 517)" fill="red" opacity="0"/>
          <g data-type="innerShadowGroup">
            <path id="favoriteManage-2" className="fill" data-name="favoriteManage" d="M139.368,176.951a1.2,1.2,0,0,0-.617-.167,1.165,1.165,0,0,0-.6.167,1.294,1.294,0,0,0-.417.467L136,180.94a.407.407,0,0,1-.15.184.741.741,0,0,1-.234.1l-3.869.551a1.129,1.129,0,0,0-.584.267,1.053,1.053,0,0,0-.35.517,1.121,1.121,0,0,0-.017.634,1.2,1.2,0,0,0,.317.551l2.8,2.721a.591.591,0,0,1,.117.217.34.34,0,0,1,.017.234l-.65,3.856a1.223,1.223,0,0,0,.067.634,1.128,1.128,0,0,0,.384.5,1.263,1.263,0,0,0,.6.217,1.216,1.216,0,0,0,.617-.134l3.452-1.819a.467.467,0,0,1,.233-.067.411.411,0,0,1,.234.067l3.469,1.819a1.117,1.117,0,0,0,.534.134,1.187,1.187,0,0,0,.684-.217,1.127,1.127,0,0,0,.384-.5,1.222,1.222,0,0,0,.067-.634l-.667-3.856a.556.556,0,0,1,.017-.234.878.878,0,0,1,.133-.217l2.8-2.721a1.2,1.2,0,0,0,.317-.551,1.034,1.034,0,0,0-.033-.634,1.052,1.052,0,0,0-.35-.517,1.118,1.118,0,0,0-.567-.267l-3.869-.551a.74.74,0,0,1-.233-.1.408.408,0,0,1-.15-.184l-1.734-3.522a1.294,1.294,0,0,0-.417-.467" transform="translate(183.243 347.217)" fill="url(#linear-gradient-favorite)"/>
          </g>
        </g>
      </svg>

    )
  }
}
